import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import useCourseBySlug from 'bundles/course-v2/hooks/useCourseBySlug';

type PropsToComponent = {
  children: React.ReactNode;
};

export const CourseContext = React.createContext<{ id?: string } | null>(null);

const CourseDataProvider = ({ children }: PropsToComponent) => {
  const router = useRouter();
  const courseSlug = router.params?.courseSlug;

  const { courseData, loading } = useCourseBySlug(courseSlug || '');

  const courseId = loading || !courseData ? undefined : courseData.courseId;
  return <CourseContext.Provider value={{ id: courseId }}>{children}</CourseContext.Provider>;
};

export default CourseDataProvider;
